import type { TemplateMeta } from '../../types';
import { CalendarIcon } from './components/Icon';
import { getDefaultRange, getRangeForAnchor } from './dateRange';

export const plannerMonthMeta: TemplateMeta = {
  name: 'Month',
  orientation: 'landscape',
  Icon: CalendarIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Calendar',
  eventListDisplayFullLabel: null,
  eventListRangePicker: 'month-range',
  getDefaultRange,
  getRangeForAnchor,
  featureFlag: 'standalonePlannerPrintableEnabled',
};
